<template>
    <label
        class="kgr-inputGroup"
        :class="{ 'kgr-inputGroup--inline': inline }"
    >
        <div
            v-if="label !== null"
            class="kgr-inputGroup__label"
        >
            {{ label }}
        </div>
        <input
            type="text"
            :value="value"
            :maxlength="maxlength"
            :placeholder="placeholder"
            class="kgr-input"
            :class="{'is-invalid': isInvalid}"
            :disabled="disabled"
            @input="onInput($event.target.value)"
            @blur="$emit('blur')"
            @change="$emit('change')"
            @keyup.enter="$emit('enter')"
        />
    </label>
</template>

<script>
export default {
    props: {
        value: {
            type: String,
            required: true,
        },
        label: {
            type: String,
            required: false,
            default: null,
        },
        inline: {
            type: Boolean,
            required: false,
            default: false,
        },
        isInvalid: {
            type: Boolean,
            required: false,
            default: false
        },
        maxlength: {
            type: Number,
            required: false,
            default: null,
        },
        placeholder: {
            type: String,
            required: false,
            default: '',
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false
        },
    },
    methods: {
        onInput(value) {
            this.$emit('input', value);
            this.$nextTick(() => {
                this.$emit('post-input', value);
            });
        }
    }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
</style>
